import React, { FC } from "react";
import "./style.scss";
import { sircapApi } from "shared/api/sircap";
import { useTranslation } from "react-i18next";
import { getCdnUrl } from "helpers/functions";

const langs = {
  en: "ENG",
  ru: "RUS",
  am: "ARM",
};

const getLang = (l: string) => {
  if (Object.keys(langs).includes(l)) {
    // @ts-ignore
    return langs[l];
  } else {
    return langs.en;
  }
};

type PropType = {
  term: string;
  CustomDoc?: string;
  CustomName?: string;
  onClick?: () => void;
  onClickText?: string;
  PrivacyPolicy?: string;
  termsOfBrokerage?: string;
  termsOfBrokerageNew?: string;
  isChecked?: boolean;
  htmlForId: string;
  onChange?: () => void;
  className?: string;
  disabled?: boolean;
  smallFont?: boolean;
  onTermClick?: (e: any) => void;
};
const TermsCheckbox: FC<PropType> = ({
  term,
  isChecked,
  CustomDoc,
  CustomName,
  PrivacyPolicy,
  termsOfBrokerage,
  termsOfBrokerageNew,
  htmlForId,
  onChange,
  className,
  disabled,
  smallFont,
  onClick,
  onClickText,
  onTermClick,
}) => {
  const { i18n } = useTranslation();
  const lang = getLang(i18n.language);

  return (
    <label
      onChange={onChange}
      htmlFor={htmlForId}
      className={`${className} termsCheckbox`}
    >
      <input
        className="checkbox"
        type="checkbox"
        checked={isChecked}
        id={htmlForId}
        readOnly
        disabled={disabled}
      />
      <p
        onClick={(e) => onTermClick && onTermClick(e)}
        style={{ fontSize: smallFont ? "12px" : "14px" }}
      >
        {term}
        {onClick && (
          <span onClick={onClick}>
            <a>{onClickText}</a>
          </span>
        )}
        {CustomDoc && (
          <a
            target="_blank"
            href={CustomDoc}
            style={{ fontSize: smallFont ? "12px" : "14px" }}
          >
            {CustomName}
          </a>
        )}
        {PrivacyPolicy && (
          <a
            target="_blank"
            href={getCdnUrl(`Privacy policy ${lang}.pdf`, "document")}
          >
            {PrivacyPolicy}
          </a>
        )}
        {termsOfBrokerage && (
          <a
            style={{ fontSize: smallFont ? "12px" : "14px" }}
            target="_blank"
            className="brokerage-services"
            href={getCdnUrl("Terms Of Brokerage Services.pdf", "document")}
          >
            {termsOfBrokerage}
          </a>
        )}
        {termsOfBrokerageNew && (
          <a
            style={{ fontSize: smallFont ? "12px" : "14px" }}
            target="_blank"
            className="brokerage-services"
            href={getCdnUrl(
              `New Terms of Business ${
                i18n.language === "ru" ? "RU" : "AM"
              }.pdf`,
              "document"
            )}
          >
            {termsOfBrokerageNew}
          </a>
        )}
      </p>
    </label>
  );
};

export default TermsCheckbox;
